module.exports = __webpack_public_path__ + "static/media/liberated.95872fff.png";